import $ks from "../lib/ks";
import efSound from "../lib/efSound";
import DrawTimeToClock from "../lib/drawTimeToClock";

class TimerAni {
    constructor(common, timerAniParams) {
        this.common = common;

        this.aniPage = $ks.getById('timer_aniPage');
        this.aniType = undefined;

        this.tabBtns = $ks.getById('timer_aniPage_tabBtns');
        this.timerBtn = $ks.getByClass('timer', this.tabBtns, 0);
        this.stopWatchBtn = $ks.getByClass('stopWatch', this.tabBtns, 0);

        this.startPauseBtn = $ks.getById('timer_aniPage_playPauseBtn');
        this.stopBtn = $ks.getById('timer_aniPage_stopBtn');

        this.go2timer = timerAniParams.go2timer;
        this.go2stopWatch = timerAniParams.go2stopWatch;

        this.clock = $ks.getById('timer_aniPage_clock');
        this.drawTimeToClock = new DrawTimeToClock(this.clock);
        this.totalTime = 0;
        this.passedTime = 0;
        this.timeInterval = 0;

        this.clockAniBox = $ks.getById('timer_aniBox_clock');
        this.clockAni = null;
        this.clockAniShadow = $ks.getById('timer_aniBox_clock_shadow');

        this.bombAniMainBox = $ks.getById('timer_aniBox_bombMain');
        this.bombAniMain = null;
        this.bombAniEndingBox = $ks.getById('timer_aniBox_bombEnding');
        this.bombAniEnding = null;

        this.sandAniBox = $ks.getById('timer_aniBox_sand');
        this.sandAni = null;

        this.sounds = []; // sounds
    }

    // initialization methods (최초 1회 실행)
    init() {
        this.setTaps();
        this.setBtns();
        this.drawTimeToClock.init();
    }

    initSound(name, src, callback) {
        if (this.soundLoaded(name)) return;
        let sound = document.createElement('audio');
        sound.setAttribute('preload', '');
        function firstLoad() {
            sound.removeEventListener('loadeddata', firstLoad);
            sound.load();
        }

        sound.addEventListener('loadeddata', firstLoad);

        sound.src = src;

        this.setSound(name, sound);
    }

    setTaps() {
        $ks.addDownEvents(this.tabBtns, {
            additionalFn: (e, classType) => {
                if (classType === 'add') {
                    if (this.isOnStopWatchBtn(e)) {
                        $ks.addClass(this.stopWatchBtn, 'hover');
                        $ks.addClass(this.stopWatchBtn, 'clicked');
                    } else {
                        $ks.addClass(this.timerBtn, 'hover');
                        $ks.addClass(this.timerBtn, 'clicked');
                    }
                }
                else {
                    if (e.type === 'mouseleave' || e.type === 'touchcancel') {
                        $ks.removeClass(this.timerBtn, 'clicked');
                        $ks.removeClass(this.stopWatchBtn, 'clicked');
                        $ks.removeClass(this.timerBtn, 'hover');
                        $ks.removeClass(this.stopWatchBtn, 'hover');
                    } else {
                        $ks.removeClass(this.timerBtn, 'clicked');
                        $ks.removeClass(this.stopWatchBtn, 'clicked');
                    }
                }
                return;
            }
        });

        this.tabBtns.addEventListener('mousemove', (e) => {
            if (this.isOnStopWatchBtn(e)) {
                $ks.addClass(this.stopWatchBtn, 'hover');
                $ks.removeClass(this.timerBtn, 'hover');
            } else {
                $ks.removeClass(this.stopWatchBtn, 'hover');
                $ks.addClass(this.timerBtn, 'hover');
            }
        }, false);
        this.tabBtns.addEventListener('click', (e) => {
            if (this.isOnStopWatchBtn(e)) {
                this.quit();
                this.go2stopWatch();
            } else {
                this.quit();
                this.go2timer();
            }
        }, false);
    }

    setBtns() {
        $ks.addHoverEvents(this.startPauseBtn);
        $ks.addDownEvents(this.startPauseBtn);
        this.startPauseBtn.addEventListener('click', (e) => {
            this.startPauseBtnClickEv(e);
        }, false);
        $ks.addHoverEvents(this.stopBtn);
        $ks.addDownEvents(this.stopBtn);
        this.stopBtn.addEventListener('click', (e) => {
            this.stopBtnClickEv(e);
        }, false);
    }

    // 동작 관련 methods (계속 실행)
    start(type, time) {
        this.reset();

        this.totalTime = time;

        this.initSound('clock', './src/snd/timerNstopWatch/timer_clock.mp3'); // 음원 설정 (최초 1회 실행)

        this.startAni(type);
    }

    startAni(type) {
        this.aniType = this.aniType !== type ? type : this.aniType;

        this['start_' + this.aniType]();
    }

    startTimeInterval(intervalFn) {
        this.timeInterval = window.setInterval(() => {
            if (!this.remainedTime) {
                this['end_' + this.aniType]();
            } else {
                this.setPassedTime = 1;
                this.drawTimeToClock.drawTime(this.remainedTime);
                if (this.sounds.clock.paused) {
                    this.sounds.clock.volume = 1;
                    this.sounds.clock.play();
                }
                if (this.sounds.clock.duration - this.sounds.clock.currentTime <= 1.13) {
                    this.sounds.clock.currentTime = 0;
                }
                if (intervalFn) intervalFn();
            }
        }, 10);

        $ks.removeClass(this.startPauseBtn, 'play');
    }

    pauseTimeInterval() {
        this.sounds.clock.pause();
        window.clearInterval(this.timeInterval);
        this.drawTimeToClock.drawTime(this.remainedTime);
    }

    endTimeInterval() {
        window.clearInterval(this.timeInterval);
        this.passedTime = 0;
        this.drawTimeToClock.drawTime(this.remainedTime);

        $ks.addClass(this.startPauseBtn, 'play');
        if (this.sounds.clock) {
            this.sounds.clock.pause();
            this.sounds.clock.currentTime = 0;
        }
    }

    startPauseBtnClickEv(e) {
        if ($ks.hasClass(e.target, 'play')) {
            $ks.removeClass(e.target, 'play');
            this['start_' + this.aniType]();
        } else {
            $ks.addClass(e.target, 'play');
            if (this['pause_' + this.aniType]) this['pause_' + this.aniType]();
            else this.pauseTimeInterval();
        }
    }

    stopBtnClickEv(e) {
        this.endTimeInterval();
        if (this['reset_' + this.aniType]) this['reset_' + this.aniType]();
        $ks.addClass(this.startPauseBtn, 'play');
    }

    // ani 제어 관련 method sets (start, pause, reset, end)
    startAniInterval(target, frames, width, height, limit_x) {
        let cnt = Math.floor(frames * (1 - this.timeRatio));
        if (cnt !== frames)
            $ks.XYtransforming(target, -width * (cnt % limit_x), -height * Math.floor(cnt / limit_x));
    }

    start_clock() {
        this.initSound('timeOver2', './src/snd/timerNstopWatch/timer_time_over2.mp3'); // 음원 설정 (최초 1회 실행)

        $ks.addClass(this.clockAniBox, 'on');
        $ks.addClass(this.clockAniShadow, 'on');

        if (!this.clockAni) {
            this.clockAni = new Image();
            this.aniPage.style.opacity = 0;
            this.clockAni.addEventListener('load', () => {
                this.aniPage.style.opacity = 1;
                this.startTimeInterval(() => {
                    this.startAniInterval(this.clockAni, 60, 530, 630, 15);
                });
            });
            this.clockAni.src = "./src/img/timer/aniPage/clock_ani_sprite.png";
            this.clockAniBox.appendChild(this.clockAni);
        } else {
            this.startTimeInterval(() => {
                this.startAniInterval(this.clockAni, 60, 530, 630, 15);
            });
        }
    }
    reset_clock() { $ks.XYtransforming(this.clockAni, 0, 0) }
    end_clock() {
        this.endTimeInterval();
        $ks.XYtransforming(this.clockAni, 0, 0);

        this.playAudio("timeOver2"); // audio 재생
    }

    start_bomb() {
        this.initSound('boom', './src/snd/timerNstopWatch/timer_boom.mp3'); // 음원 설정 (최초 1회 실행)

        $ks.addClass(this.bombAniMainBox, 'on');
        if (!this.bombAniMain) {
            this.bombAniMain = new Image();
            this.aniPage.style.opacity = 0;
            this.bombAniMain.addEventListener('load', () => {
                this.aniPage.style.opacity = 1;
                this.startTimeInterval(() => {
                    this.startAniInterval(this.bombAniMain, 115, 780, 582, 10);
                });
                this.bombAniEnding = new Image();
                this.bombAniEnding.src = "./src/img/timer/aniPage/bomb_ani_sprite_ending.png";
                this.bombAniEndingBox.appendChild(this.bombAniEnding);
            });
            this.bombAniMain.src = "./src/img/timer/aniPage/bomb_ani_sprite_main.png";
            this.bombAniMainBox.appendChild(this.bombAniMain);
        } else {
            this.startTimeInterval(() => {
                this.startAniInterval(this.bombAniMain, 115, 780, 582, 10);
            });
        }
    }
    reset_bomb() { $ks.XYtransforming(this.bombAniMain, 0, 0) }
    end_bomb() {
        this.endTimeInterval();
        $ks.removeClass(this.bombAniMainBox, 'on');
        $ks.addClass(this.bombAniEndingBox, 'on');

        let intervalID = 0,
            totalTime = 1000,
            passedTime = 0,
            cnt = 0;

        intervalID = window.setInterval(() => {
            if (totalTime === passedTime) {
                window.clearInterval(intervalID);
                $ks.XYtransforming(this.bombAniMain, 0, 0);
                $ks.addClass(this.bombAniMainBox, 'on');
                $ks.removeClass(this.bombAniEndingBox, 'on');
            } else {
                passedTime += 10;
                cnt = Math.floor(11 * (passedTime / totalTime));
                if (cnt !== 11)
                    $ks.XYtransforming(this.bombAniEnding, -1280 * (cnt % 3), -800 * Math.floor(cnt / 3));
            }
        }, 10);

        this.playAudio("boom"); // audio 재생
    }

    start_sand() {
        this.initSound('timeOver2', './src/snd/timerNstopWatch/timer_time_over2.mp3'); // 음원 설정 (최초 1회 실행)

        $ks.addClass(this.sandAniBox, 'on');
        if (!this.sandAni) {
            this.sandAni = new Image();
            this.aniPage.style.opacity = 0;
            this.sandAni.addEventListener('load', () => {
                this.aniPage.style.opacity = 1;
                this.startTimeInterval(() => {
                    this.startAniInterval(this.sandAni, 121, 378, 673, 21);
                });
            });
            this.sandAni.src = "./src/img/timer/aniPage/sand_ani_sprite.png";
            this.sandAniBox.appendChild(this.sandAni);
        } else {
            this.startTimeInterval(() => {
                this.startAniInterval(this.sandAni, 121, 378, 673, 21);
            });
        }
    }
    reset_sand() { $ks.XYtransforming(this.sandAni, 0, 0) }
    end_sand() {
        this.endTimeInterval();
        $ks.XYtransforming(this.sandAni, 0, 0);

        this.playAudio("timeOver2"); // audio 재생
    }

    start_digital() {
        this.initSound('timeOver2', './src/snd/timerNstopWatch/timer_time_over2.mp3'); // 음원 설정 (최초 1회 실행)

        $ks.addClass(this.clock, 'on');
        this.startTimeInterval();
    }
    end_digital() {
        this.endTimeInterval();

        this.playAudio("timeOver2"); // audio 재생
    }

    // sounds 세팅
    setSound(name, element) {
        this.sounds[name] = element;
    }

    // 오디오 재생 될 때까지 interval (iOS 대응)
    playAudio(name) {
        let audioElement = this.sounds[name];
        audioElement.interval = setInterval(intervalFnc, 10);
        function intervalFnc() {
            if (audioElement.paused) {
                audioElement.currentTime = 0;
                audioElement.play();
            }
        }
        function endedCallback() {
            audioElement.removeEventListener('ended', endedCallback);
            clearInterval(audioElement.interval);

            audioElement.pause();
            audioElement.currentTime = 0;
        }
        audioElement.addEventListener('ended', endedCallback);
    }

    // 소리 켜기
    onSounds() {
        if (!!this.sounds) {
            for (let name in this.sounds) {
            }
        }
    }

    // 소리 끄고 초기화하기
    offSounds() {
        if (!!this.sounds) {
            for (let name in this.sounds) {
                let sound = this.sounds[name];
                if (sound.interval) {
                    sound.pause();
                    sound.currentTime = 0;
                    clearInterval(sound.interval);
                }
            }
        }
    }

    // 판단 관련 methods
    isOnStopWatchBtn(e) {
        let x1, x2, y1, y2, isOnStopWatchBtn;
        x1 = $ks.getSize(this.stopWatchBtn, 'left');
        x2 = $ks.getSize(this.stopWatchBtn, 'left') + $ks.getSize(this.stopWatchBtn, 'width');
        y1 = $ks.getSize(this.stopWatchBtn, 'top');
        y2 = $ks.getSize(this.stopWatchBtn, 'top') + $ks.getSize(this.stopWatchBtn, 'height');
        isOnStopWatchBtn = e.clientX > x1 && e.clientX < x2 && e.clientY > y1 && e.clientY < y2;

        return isOnStopWatchBtn;
    }

    // 초기화 관련 methods
    reset() {
        this.common.bgSwitcher('timerAni');
        this.common.bodyBgSizer('timerAni');

        this.resetClockAni();
        this.resetBombAni();
        this.resetSandAni();

        $ks.removeClass(this.clock, 'on');
        $ks.addClass(this.aniPage, 'on');

        this.common.tabs.forEach((tab) => {
            $ks.removeClass(tab, 'on');
        });

        this.common.mains.forEach((main) => {
            $ks.removeClass(main, 'on');
        });

        this.onSounds();
    }

    resetClockAni() {
        if (this.clockAniBox) $ks.removeClass(this.clockAniBox, 'on');
        if (this.clockAniShadow) $ks.removeClass(this.clockAniShadow, 'on');
        this.reset_clock();
    }

    resetBombAni() {
        if (this.bombAniMainBox) $ks.removeClass(this.bombAniMainBox, 'on');
        if (this.bombAniEndingBox) $ks.removeClass(this.bombAniEndingBox, 'on');
        this.reset_bomb();
    }

    resetSandAni() {
        if (this.sandAniBox) $ks.removeClass(this.sandAniBox, 'on');
        this.reset_sand();
    }

    quit() {
        this.endTimeInterval();
        this.resetClockAni(); // 알람시계
        this.resetBombAni(); // 폭탄
        this.resetSandAni(); // 모래시계
        $ks.removeClass(this.clock, 'on'); // 디지털시계
        $ks.removeClass(this.aniPage, 'on');

        this.offSounds();
    }

    // sound가 load되었는가?
    soundLoaded(name) { return !!this.sounds[name]; }

    ////////////
    // getter //
    ////////////
    get remainedTime() { return this.totalTime - this.passedTime; }
    get timeRatio() { return this.remainedTime / this.totalTime; }

    ////////////
    // setter //
    ////////////
    set setPassedTime(time) { this.passedTime += time; }
}

export default TimerAni;
